function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { mapState } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import SegmentTablesComponent from '@/apps/audiences/components/SegmentTablesComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { filterMixin } from '@/mixins/filter_mixin';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
import ValueRangeConfig from './ValueRangeConfig.vue';
export default {
  name: 'ProductizeTransformedAttributesCreate',
  components: {
    SegmentTablesComponent: SegmentTablesComponent,
    PaginationVue: PaginationVue,
    ValueRangeConfig: ValueRangeConfig,
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    mode: {
      type: String,
      default: 'create'
    },
    initialData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    forbiddenTableNames: {
      type: Array,
      default: function _default() {
        return [];
      } // e.g. ['clientes', 'ventas_2024', ...]
    }
  },
  data: function data() {
    var _this = this,
      _ref;
    return _ref = {
      headersStats: [{
        text: 'Periodo',
        value: 'periodo'
      }, {
        text: 'Atributo',
        value: 'atributo'
      }, {
        text: 'Cantidad',
        value: 'cantidad'
      }, {
        text: 'Promedio',
        value: 'promedio'
      }, {
        text: 'STD',
        value: 'std'
      }, {
        text: 'Mínimo',
        value: 'minimo'
      }, {
        text: 'Máximo',
        value: 'maximo'
      }],
      statisticsFields: []
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "statisticsFields", []), "NUMERIC_TYPES_CANONICAL", [
    // BigQuery
    'int64', 'float64', 'numeric', 'bignumeric',
    // Aliases comunes
    'int', 'integer', 'bigint', 'smallint', 'tinyint', 'byteint', 'double', 'double precision', 'decimal', 'bigdecimal', 'real',
    // Athena/Presto/Hive
    'integer', 'float', 'double', 'decimal', 'number']), "NUMERIC_TYPE_REGEXES", [
    // decimal(10,2), numeric(38,9), etc.
    /^\s*(decimal|numeric)\s*\(\s*\d+\s*(,\s*\d+\s*)?\)\s*$/i]), "attrMessage", ''), "attrError", false), "maxChips", 6), "maxAttributes", 40), "minGap", 2), "localForbiddenTableNames", []), "rangeSections", []), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "schemasByUnit", ['']), "filtro", {
      category: [],
      category_comma: '',
      q: '',
      per_page: 5,
      page: 1,
      not_null_without_value: true,
      not_null_min: 0,
      not_null_max: 100,
      include_no_available: false
    }), "e1", this.currentStep || 1), "hasFile", false), "list_orgs", []), "valid", false), "editFile", false), "modelInitiallyEmpty", false), "isValidChips", true), "isValidAttributes", true), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "isValidTree", true), "flag_alert", false), "edit", true), "type_export_items", null), "segments", []), "processDates", []), "isValidated", false), "warningMessage", ''), "keyPrevisualize", 1), "File", []), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fileBase64", null), "hasTables", false), "headers", [{
      text: 'Atributo',
      value: 'attribute_name'
    }]), "tableInternalItems", []), "selectedItem", null), "searchQuery", ""), "internalSelected", []), "aws_schemes", []), "form", {
      model: null,
      type_export: null,
      selected_use_case: null,
      segment: null,
      destination_scheme: null,
      selected_destination_scheme: null,
      description: null,
      py_file: null,
      number_day: null,
      weekDays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      week_day: null,
      number: '',
      numberRules: [function (v) {
        return !v || v >= 1 && v <= 28 || 'Por favor ingresa un número entre 1 y 28';
      }, function (v) {
        return !isNaN(parseFloat(v)) || 'Debe ser un número';
      }],
      has_pls: false,
      transformation_type: null,
      transformation_types: ['Manual', 'PLS', 'Binning']
    }), "viewsData", []), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "segmentIsValid", true), "keySearchTable", 1), "rules", {
      segment: function segment(value) {
        return !!value || 'Este campo es requerido.';
      },
      campo: [function (v) {
        if (_this.e1 > 1 && _this.form.has_pls) {
          return !!v || _this.translate('reglas.field');
        }
        return true;
      }],
      max_length: function max_length(value) {
        return value && value.length <= 10 || _this.translate('reglas.nombre_max_10');
      },
      min_length: function min_length(value) {
        return value && value.length >= 3 || _this.translate('reglas.nombre_min');
      },
      segment_format: function segment_format(value) {
        return /^[a-z0-9_]+$/i.test(value) || _this.translate('reglas.nombre_formato');
      },
      destination_scheme: [function (v) {
        return !!v || _this.translate('reglas.field');
      }],
      month: [function (v) {
        return !!v || _this.translate('reglas.field');
      }],
      description: [function (v) {
        return !!v || _this.translate('reglas.field');
      }],
      selected_use_case: [function (value) {
        return !!value || _this.translate('reglas.field');
      }, function (value) {
        if (!value) return true;
        if (value && value.partyid_match && value.partyid_match.table_id && value.source && value.source.toLowerCase() !== 'athena') return true;
        if (value && value.source && value.source.toLowerCase() == 'athena') return true;
        return 'EL caso de uso no tiene un filtro asociado.';
      }],
      type_export: [function (value) {
        return !!value || _this.translate('reglas.field');
      }],
      model: [function (v) {
        return !!v || _this.translate('reglas.field');
      }],
      file: [function (v) {
        return !!v || _this.translate('customer_insights.rules.file');
      }, function (v) {
        return !v || v.size < 2000000 || _this.translate('customer_insights.rules.file_size');
      }],
      not_in_forbidden: function not_in_forbidden(value) {
        // Permite vacío si el campo todavía no es requerido en ese momento
        if (!value) return true;
        // Normaliza: trim + minúsculas
        var v = String(value).trim().toLowerCase();
        // Crea un Set normalizado para búsqueda O(1)
        var blocked = new Set((_this.localForbiddenTableNames || []).map(function (n) {
          return String(n.segmento).trim().toLowerCase();
        }));
        return !blocked.has(v) || 'Este nombre de tabla ya existe.';
      },
      value_int: function value_int(v) {
        return v === '' || v === null || Number(v) >= 0 || 'Ingresa un número  no negativo';
      },
      value_gap_min: function value_gap_min() {
        var minGap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
        return function (v, ctx) {
          // ctx.prev = valor anterior; ctx.index = índice actual
          if (!ctx || ctx.index <= 0) return true;
          var prev = Number(ctx.prev);
          var curr = Number(v);
          if (!Number.isFinite(prev) || !Number.isFinite(curr)) return true;
          var min = prev + minGap;
          return curr >= min || "Debe ser \u2265 ".concat(min);
        };
      }
    }), "selectedMonth", null), "selectedYear", null), "chips", []), "months", [{
      name: 'Enero',
      value: '01'
    }, {
      name: 'Febrero',
      value: '02'
    }, {
      name: 'Marzo',
      value: '03'
    }, {
      name: 'Abril',
      value: '04'
    }, {
      name: 'Mayo',
      value: '05'
    }, {
      name: 'Junio',
      value: '06'
    }, {
      name: 'Julio',
      value: '07'
    }, {
      name: 'Agosto',
      value: '08'
    }, {
      name: 'Septiembre',
      value: '09'
    }, {
      name: 'Octubre',
      value: '10'
    }, {
      name: 'Noviembre',
      value: '11'
    }, {
      name: 'Diciembre',
      value: '12'
    }]), "keyTable", 0), "isLoading", false), "weight_rows", []), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "weight_result", []), "weight_headers", []), "attributes_array", []), "groups", []), "open", []), "nextId", 1), "jsonOutput", null);
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this2 = this;
      var params, basePromises, detailPromise, _yield$Promise$all, _yield$Promise$all2, detailResponse, data, matchingUseCase, partyid_match, decoded, blob, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (this.form.has_pls) this.addGroup();
            params = {
              user: this.userEmail
            };
            basePromises = [this.fetchCatalogs(), this.getOwnerUseCasesByStatus('3', params, false), this.getListOrgsDetailed()].concat(_toConsumableArray(this.companyCode === '000' ? [this.ListIbkAwsSchemes()] : []));
            console.log('initial Data', this.initialData);
            // Dispara el más lento lo antes posible si es update
            detailPromise = this.mode === 'update' && this.initialData ? UseCasesService.getProductizeDetail({}, this.initialData.project_id, this.initialData.segment_id, this.initialData.type_export_id) : Promise.resolve(null);
            _context.p = 1;
            _context.n = 2;
            return Promise.all([Promise.all(basePromises), detailPromise]);
          case 2:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            detailResponse = _yield$Promise$all2[1];
            if (detailResponse) {
              data = detailResponse.data.records;
              matchingUseCase = this.items.find(function (u) {
                return u.id === _this2.initialData.project_id;
              }) || {};
              partyid_match = matchingUseCase.partyid_match || null;
              this.editFile = true;
              this.modelInitiallyEmpty = !this.initialData.model;
              this.form = _objectSpread(_objectSpread({}, this.form), {}, {
                transformation_type: this.initialData.tipo_transformacion === 'automatic' ? 'PLS' : tipo_transformacion.capitalize(),
                model: this.initialData.model,
                type_export: {
                  id: data.type_export_id,
                  export_type_name: data.tipo_de_exportacion
                },
                selected_use_case: {
                  id: this.initialData.project_id,
                  business_name: data.caso_de_uso,
                  owner_name: this.initialData.owner_name,
                  company_code: matchingUseCase.company_code || null,
                  partyid_match: partyid_match,
                  source: matchingUseCase.source || null,
                  db_write_name: matchingUseCase.db_write_name || ''
                },
                segment: data.nombre_tabla,
                destination_scheme: this.initialData.destination_scheme,
                selected_destination_scheme: null,
                description: data.descripcion_tabla,
                py_file: null,
                number_day: null,
                week_day: null,
                number: '',
                has_pls: data.has_pls
              });
              if (data.descargar_archivo) {
                decoded = atob(data.descargar_archivo);
                blob = new Blob([decoded], {
                  type: 'text/x-python'
                });
                this.form.py_file = new File([blob], "".concat(this.form.segment, ".py"), {
                  type: 'text/x-python'
                });
                this.fileBase64 = data.descargar_archivo;
                this.hasFile = true;
              }
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('Error en el proceso de carga:', _t);
          case 4:
            _context.p = 4;
            this.$nextTick(function () {
              return _this2.$emit('child-loaded');
            });
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, this, [[1, 3, 4, 5]]);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: _objectSpread(_objectSpread({
    canProceed: function canProceed() {
      if (this.e1 === 0) {
        // Usa el v-form v-model="valid" y todas tus rules existentes
        return !!this.valid;
      }
      if (this.e1 === 1) {
        // Usa el v-form v-model="valid" y todas tus rules existentes
        return !!this.valid;
      }
      if (this.e1 === 2) {
        // Ya calculas estos flags con tus rules / watchers
        return this.isValidChips && this.isValidAttributes && (!this.form.has_pls || this.isValidTree);
      }
      if (this.e1 === 3) {
        return true;
      }
      return false;
    },
    isBinning: function isBinning() {
      return this.form && this.form.transformation_type === 'Binning';
    },
    selectedItems: function selectedItems() {
      console.log('selectedItems computed', this.internalSelected);
      var arr = Array.isArray(this.internalSelected) ? this.internalSelected : [];
      return arr.filter(function (x) {
        return x && _typeof(x) === 'object';
      });
    }
  }, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    years: function years() {
      var currentYear = new Date().getFullYear();
      var years = [];
      for (var i = 0; i < 5; i++) {
        var year = currentYear - i;
        years.push({
          name: year.toString(),
          value: year.toString()
        });
      }
      return years;
    },
    segmentValidation: function segmentValidation() {
      var _this3 = this;
      return function (value) {
        if (!_this3.segmentIsValid) {
          return 'Segmento ya existe.';
        } else {
          return _this3.segmentIsValid;
        }
      };
    },
    filteredItems: function filteredItems() {
      if (!this.searchQuery) return this.tableInternalItems || [];
      var query = this.searchQuery.toLowerCase().trim();
      var filtered = (this.tableInternalItems || []).filter(function (item) {
        return item.attribute_name && item.attribute_name.toLowerCase().startsWith(query);
      });
      return filtered;
    }
  }),
  watch: {
    'form.selected_use_case': 'syncSchema',
    aws_schemes: function aws_schemes() {
      this.syncSchema();
    },
    currentStep: function currentStep(val) {
      if (val !== this.e1) this.e1 = val;
    },
    e1: function e1(val) {
      // Propaga al padre cuando cambie localmente
      this.$emit('update:currentStep', val);
    },
    internalSelected: function internalSelected(newVal, oldVal) {
      var _this4 = this;
      var arr = Array.isArray(newVal) ? newVal : [];

      // SOLO en Binning filtra no numéricos
      var sane = this.isBinning ? arr.filter(function (it) {
        return _this4.canSelectItem(it);
      }) : arr;
      if (sane.length !== arr.length) {
        this.internalSelected = sane;
        this.attrError = true;
        this.attrMessage = 'Se quitaron atributos no numéricos de la selección.';
        return;
      }

      // solo en Binning:
      if (this.isBinning && sane.length > this.maxAttributes) {
        this.attrError = true;
        this.attrMessage = "M\xE1ximo ".concat(this.maxAttributes, " atributos permitidos.");
        this.internalSelected = oldVal;
        tasks.toast.info("M\xE1ximo ".concat(this.maxAttributes, " atributos permitidos"));
        return;
      }

      // mensajes
      if (this.isBinning && sane.length === this.maxAttributes) {
        this.attrError = false;
        this.attrMessage = "Has alcanzado el m\xE1ximo permitido (".concat(this.maxAttributes, ").");
      } else {
        this.attrError = false;
        this.attrMessage = '';
      }
      this.verificarChipsYAtributos();
    },
    'form.segment': function formSegment(newVal) {
      if (newVal) {
        this.form.segment = newVal.toLowerCase();
      }
    }
  },
  methods: {
    syncSchema: function syncSchema() {
      var s = this.form.selected_use_case || {};
      this.form.destination_scheme = s.db_write_name.replace("_rlink", "") || '';
      console.log('syncSchema', this.form.destination_scheme);
    },
    isNullOrZero: function isNullOrZero(val) {
      // Trata "0", 0, null, undefined, '' como vacíos/ceros
      if (val === null || val === undefined || val === '') return true;
      var n = Number(val);
      return Number.isFinite(n) && n === 0;
    },
    cellClassNum: function cellClassNum(val) {
      return this.isNullOrZero(val) ? 'soft-red-cell soft-red-text' : '';
    },
    formatNum: function formatNum(val) {
      // Muestra guion si es null/undefined/''; si es número, formatea simple
      if (val === null || val === undefined || val === '') return '—';
      var n = Number(val);
      return Number.isFinite(n) ? n.toString() : String(val);
    },
    getStatisticsFields: function getStatisticsFields() {
      var _this5 = this;
      var GCP_TO_AWS = {
        'ba_itc_attr_bienestar': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_bienestar'
        },
        'ba_itc_attr_corporate': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_corporate'
        },
        'ba_itc_attr_demographic': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_demographic'
        },
        'ba_itc_attr_digital': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_digital'
        },
        'ba_itc_attr_entertainment': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_entertainment'
        },
        'ba_itc_attr_insurance': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_insurance'
        },
        'ba_itc_attr_payment_pos': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_payment_pos'
        },
        'ba_itc_attr_rcc': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_rcc'
        },
        'ba_itc_attr_retail': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_retail'
        },
        'ba_itc_aud_category': {
          esquema: 'sand_ibk_itcm_base_rlink',
          tabla: 'sand_attr_interest'
        }
      };
      console.log('selectedItems', this.selectedItems);
      // 1) Obtener los seleccionados desde el computed
      var items = this.selectedItems || [];
      if (!items.length) {
        this.statisticsFields = [];
        return;
      }

      // 2) Agrupar por esquema+tabla
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var it = _step.value;
          var tabla_gcp = it.attribute_object_name;
          var esquema = GCP_TO_AWS[tabla_gcp].esquema;
          var tabla = GCP_TO_AWS[tabla_gcp].tabla;
          // ej: "ba_itc_aud_category"
          var key = "".concat(esquema, "::").concat(tabla);
          if (!map.has(key)) {
            map.set(key, {
              esquema: esquema,
              tabla: tabla,
              atributos: []
            });
          }
          map.get(key).atributos.push(it.attribute_name);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var periodos = _toConsumableArray(new Set((this.chips || []).map(function (c) {
        return _this5.toProcessDate(c.id);
      }) // 'YYYYMM' -> 'YYYY-MM-01'
      .filter(Boolean)));

      // 4) Construir grupos y body
      var groups = Array.from(map.values()).map(function (g) {
        return _objectSpread(_objectSpread({}, g), periodos.length ? {
          periodos: periodos
        } : {});
      });
      var body = groups;

      // 5) Llamar al servicio y poblar la tabla
      return UseCasesService.getStatisticsFields(body).then(function (response) {
        console.log('Statistics response', response);
        if (response) {
          var data = response && response.data ? response.data : response;
          var _items = data && Array.isArray(data.records) ? data.records : [];
          _this5.statisticsFields = _items;
        } else {
          _this5.statisticsFields = [];
        }
      }).catch(function (err) {
        console.error('Error fetching statistics fields:', err);
        _this5.statisticsFields = [];
      });
    },
    // Normaliza y decide si el tipo es numérico
    isNumericType: function isNumericType(rawType) {
      console.log('isNumericType', rawType);
      if (!rawType) return false;
      var t = String(rawType).trim().toLowerCase();

      // Coincidencia exacta en la lista “canónica”
      if (this.NUMERIC_TYPES_CANONICAL.includes(t)) return true;

      // Casos como "decimal(10,2)" o "numeric(38,9)"
      if (this.NUMERIC_TYPE_REGEXES.some(function (rx) {
        return rx.test(t);
      })) return true;

      // Algunas fuentes traen extras: "INT64 NULLABLE", "double precision not null"
      var cleaned = t.replace(/\b(nullable|not null|required|optional)\b/g, '').trim();
      if (this.NUMERIC_TYPES_CANONICAL.includes(cleaned)) return true;
      if (this.NUMERIC_TYPE_REGEXES.some(function (rx) {
        return rx.test(cleaned);
      })) return true;

      // Heurística suave para athena/presto/hive
      if (/(int|float|double|real|numeric|decimal|bigint|smallint|tinyint)/i.test(t)) return true;
      return false;
    },
    // ¿Se permite seleccionar este item?
    canSelectItem: function canSelectItem(item) {
      console.log('canSelectItem', item);
      return !!item;
      //return !!item && this.isNumericType(item.attribute_data_type)
    },
    // Para dar estilo a filas no numéricas (opcional)
    rowClass: function rowClass(item) {
      console.log('rowClass', item);
      return this.canSelectItem(item) ? '' : 'row-nonnumeric';
    },
    onRemoveFromRange: function onRemoveFromRange(sectionId) {
      // Asegura comparar como string para evitar problemas número/string
      var idStr = String(sectionId);
      this.internalSelected = (this.internalSelected || []).filter(function (it) {
        return String(it.id) !== idStr;
      });

      // (Opcional) si quieres que el checkbox de la tabla refleje al toque usando la API:
      // this.$refs.attrTable?.toggleSelect({ id: sectionId })  // si tienes ref y el item visible
    },
    unselect: function unselect(item) {
      console.log('item to unselect', item);
      var key = item.uid || item.attribute_name;
      this.internalSelected = this.internalSelected.filter(function (i) {
        return (i.uid || i.attribute_name) !== key;
      });
    },
    sendToSearch: function sendToSearch() {
      var _this6 = this;
      this.tableInternalItems = [];
      console.log(this.filtro);
      var filtro = _objectSpread(_objectSpread({}, this.filtro), {}, {
        q: this.searchQuery,
        company_code: this.form.selected_use_case.company_code
      });
      search_engine_service.getBuscadorAtributos(filtro).then(function (response) {
        if (response.busqueda && response.busqueda.length > 0) {
          _this6.tableInternalItems = response.busqueda.map(function (match) {
            var uid = [match.proyecto, match.dataset, match.tabla, match.nombre].map(function (x) {
              return String(x || '').toLowerCase();
            }).join('::');
            return {
              uid: uid,
              id: match.id,
              attribute_name: match.nombre,
              attribute_object_name: match.tabla,
              attribute_scheme_name: match.dataset,
              attribute_project_name: match.proyecto,
              attribute_category: match.categoria,
              attribute_data_type: match.tipo_dato
            };
          });
        }
        return null;
      }).catch(function (error) {
        console.error("Error buscando atributo \"".concat(attribute, "\""), error);
        return null;
      });
      console.log('this.tableInternalItems', this.tableInternalItems);
    },
    emitTransformationType: function emitTransformationType() {
      var t = this.form.transformation_type;
      this.form.has_pls = t === 'PLS';

      // Si activas PLS y no hay grupos, crea uno
      if (this.form.has_pls && this.groups.length === 0) {
        this.addGroup();
      }

      // Si NO es Binning, limpia reglas/mensajes de Binning
      if (t === 'Binning') {
        this.internalSelected = (this.internalSelected || []).filter(this.canSelectItem);
      } else {
        this.attrError = false;
        this.attrMessage = '';
      }
      this.$emit('transformation-type-changed', this.form.transformation_type);
    },
    onSegmentChange: function () {
      var _onSegmentChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var value, datos, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              value = this.form.segment;
              if (!(!value || !this.form.selected_use_case || !this.form.selected_use_case.id || !this.form.type_export || !this.form.type_export.id)) {
                _context2.n = 1;
                break;
              }
              this.segmentIsValid = true;
              _context2.n = 5;
              break;
            case 1:
              datos = {
                project_id: this.form.selected_use_case.id,
                segment: value,
                type_export_id: this.form.type_export.id
              };
              _context2.p = 2;
              _context2.n = 3;
              return UseCasesService.postTableIdAutomate(datos);
            case 3:
              response = _context2.v;
              if (response && response.data) {
                this.segmentIsValid = response.data.status_export;
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('Error al validar el segmento:', _t2);
            case 5:
              // Desencadenar la validación manualmente después de cambiar.
              this.$refs.segmentField.validate();
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function onSegmentChange() {
        return _onSegmentChange.apply(this, arguments);
      }
      return onSegmentChange;
    }(),
    triggerSegmentValidation: function triggerSegmentValidation() {
      if (!this.form.selected_use_case.partyid_match && this.mode !== 'update' && this.form.selected_use_case.source.toLowerCase() !== 'athena') {
        tasks.toast.info('El caso de uso no tiene un filtro asociado.');
      }
      this.$refs.segmentField.validate();
      this.onSegmentChange();
    },
    fetchDataAndCombine: function fetchDataAndCombine() {
      this.columns_selected = [];
      this.viewsData = [];
      var params = {
        user: this.serviceAccount
      };
      var dataFetched = {
        approved: [],
        revision: []
      };
      return Promise.all([MyAccessService.getObjectAccess('productivize', params).then(function (response) {
        if (response && response.data) {
          response.data.forEach(function (element) {
            var item = {
              text: element.table.id.replace(':', '.'),
              value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
              data: element,
              status: 'APPROVED'
            };
            dataFetched.approved.push(item);
          });
        }
      }), MyAccessService.getObjectAccessWithPending('productivize', params).then(function (response) {
        if (response && response.data) {
          response.data.forEach(function (element) {
            var item = {
              text: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
              value: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
              data: element,
              status: 'REVISION'
            };
            dataFetched.revision.push(item);
          });
        }
      })]).then(function () {
        return dataFetched;
      });
    },
    cleanAndPrioritizeData: function cleanAndPrioritizeData(dataFetched) {
      var _this7 = this;
      // priorizar en estado revision
      var addItemToViewsData = function addItemToViewsData(item) {
        var existingIndex = _this7.viewsData.findIndex(function (existingItem) {
          return existingItem.text === item.text;
        });
        if (existingIndex !== -1) {
          if (item.status === 'REVISION' && _this7.viewsData[existingIndex].status === 'APPROVED') {
            _this7.viewsData[existingIndex] = item;
          }
        } else {
          _this7.viewsData.push(item);
        }
      };
      dataFetched.revision.forEach(addItemToViewsData);
      dataFetched.approved.forEach(addItemToViewsData);
    },
    getObjectAccess: function getObjectAccess() {
      var _this8 = this;
      this.fetchDataAndCombine().then(function (dataFetched) {
        _this8.cleanAndPrioritizeData(dataFetched);
      });
    },
    mapearArray: function mapearArray(valor) {
      return valor.filter(function (field) {
        return field.column !== undefined && field.column !== null;
      }).map(function (field) {
        return field.column.toString();
      });
    },
    onTableSelected: function onTableSelected(item, selectedValue) {
      var _this9 = this;
      this.flag_alert = false;
      this.columns_selected = [];
      if (selectedValue.data.status === 'REVISION') {
        item.company_code_table = this.getCodeFromDomain(selectedValue.data.domain_table);
        var columnas = this.mapearArray(selectedValue.data.fields);
        if (!this.arrayContains(columnas, item.attribute_names)) {
          item.table_Inca = null;
          item.status_aprov = null;
          tasks.toast.info('La tabla no tiene los mismos campos que el caso de uso');
          this.keySearchTable += 1;
          this.verificarAlerta();
          return;
        }
        item.flag_access = true;
        item.status_aprov = false;
      } else {
        item.company_code_table = this.getCodeFromDomain(selectedValue.data.domain);
        if (this.viewsData.length > 0 && Object.keys(selectedValue).length > 0) {
          var params = {
            relativeResourceName: selectedValue.data.relativeResourceName,
            domain_table: selectedValue.data.domain
          };
          AssignmentsService.getListTagEntry(params).then(function (response) {
            if (response && response.code === 200) {
              var responseTPL = response.data;
              var tableTags = responseTPL.objects.tags;
              _this9.items = tableTags.filter(function (tag) {
                return !!tag.column;
              });
              _this9.columns_selected = [];
              _this9.partyId = null;
              _this9.keySearchTable += 1;
              _this9.$refs.form.resetValidation();
              var _columnas = _this9.mapearArray(tableTags);
              _this9.verificarAlerta();
              if (!_this9.arrayContains(_columnas, item.attribute_names)) {
                item.table_Inca = null;
                item.status_aprov = null;
                tasks.toast.info('La tabla no tiene los mismos campos que el caso de uso');
                return;
              }
              item.flag_access = false;
              item.status_aprov = true;
            }
          });
        }
      }
      item.table_replace = null;
      item.view_id_replace = selectedValue.value;
      this.verificarAlerta();
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    },
    backStep: function backStep(event) {
      if (this.e1 > 1) {
        this.e1--;
        this.$emit('update-step', this.e1);
        // Puedes llamar a un método aquí según el valor de this.e1 si lo necesitas
      }
    },
    nextStep: function () {
      var _nextStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
        var problematic, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.validate()) {
                _context3.n = 1;
                break;
              }
              console.log('Formulario no válido');
              return _context3.a(2);
            case 1:
              if (!(this.e1 <= 4)) {
                _context3.n = 8;
                break;
              }
              // Limitar a que no sea mayor que 3
              this.e1++;
              _t3 = this.e1;
              _context3.n = _t3 === 2 ? 2 : _t3 === 3 ? 5 : _t3 === 4 ? 7 : 8;
              break;
            case 2:
              if (!(this.form.transformation_type !== 'Binning')) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return this.readPythonFile();
            case 3:
              _context3.n = 4;
              return this.listTables();
            case 4:
              return _context3.a(3, 8);
            case 5:
              _context3.n = 6;
              return this.getStatisticsFields();
            case 6:
              return _context3.a(3, 8);
            case 7:
              problematic = this.statisticsFields.some(function (item) {
                return [item.cantidad, item.promedio, item.std, item.minimo, item.maximo].some(function (val) {
                  return val === null || val === undefined || val === '' || val === 0;
                });
              });
              if (problematic) {
                this.$refs.confirm.onOpen(); // 👈 abre el modal
                // detén el flujo hasta confirmar
              } else {
                this.mode === 'create' ? this.SaveAndExecute() : this.UpdateAndExecute();
              }
              return _context3.a(3, 8);
            case 8:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function nextStep(_x) {
        return _nextStep.apply(this, arguments);
      }
      return nextStep;
    }(),
    handleConfirm: function handleConfirm(acepta) {
      if (acepta) {
        this.mode === 'create' ? this.SaveAndExecute() : this.UpdateAndExecute();
      }
      this.$refs.confirm.onClose();
    },
    dropFile: function dropFile(e) {
      this.File = e.dataTransfer.files;
      if (this.File.length > 0) {
        this.form.py_file = e.dataTransfer.files[0];
        this.onFileSelected();
      }
    },
    toProcessDate: function toProcessDate(yyyymm) {
      if (!/^\d{6}$/.test(yyyymm)) return null;
      return "".concat(yyyymm.slice(0, 4), "-").concat(yyyymm.slice(4, 6), "-01");
    },
    // Convierte chips "YYYYMM" a "YYYY-MM-01" (ya tienes toProcessDate)
    buildAttributesFromSelection: function buildAttributesFromSelection() {
      // mapa id -> ranges que viene desde <value-range-config v-model="rangeSections" ... />
      var rangesById = new Map((this.rangeSections || []).map(function (s) {
        return [String(s.id), Array.isArray(s.ranges) ? s.ranges : []];
      }));
      var sel = Array.isArray(this.internalSelected) ? this.internalSelected : [];
      return sel.map(function (item) {
        //const sourceTable = `${item.attribute_scheme_name}.${item.attribute_object_name}`
        var AWS_MAP = {
          ba_itc_aud_category: 'sand_attr_interest',
          ba_itc_attr_bienestar: 'sand_attr_bienestar',
          ba_itc_attr_entertainment: 'sand_attr_entertainment',
          ba_itc_attr_corporate: 'sand_attr_corporate',
          ba_itc_attr_demographic: 'sand_attr_demographic',
          ba_itc_attr_digital: 'sand_attr_digital',
          ba_itc_attr_insurance: 'sand_attr_insurance',
          ba_itc_attr_payment: 'sand_attr_payment_pos',
          ba_itc_attr_rcc: 'sand_attr_rcc',
          ba_itc_attr_retail: 'sand_attr_retail'
        };

        // y reemplaza tu sourceTable por esto:
        var awsName = item.aws_table_name || AWS_MAP[item.attribute_object_name] || String(item.attribute_object_name).replace(/^ba_itc_attr_/, 'sand_attr_');
        console.log('awsName', awsName, 'from', item.attribute_object_name);
        var sourceTable = "sand_ibk_itcm_base_rlink.".concat(awsName);
        // normalizamos cada rango al contrato requerido
        var rawRanges = rangesById.get(String(item.id)) || [];
        console.log('rawRanges for item', item, rawRanges);
        var ranges = rawRanges.map(function (r) {
          var range = {};
          if (r.default === true) {
            // caso default
            range.default = true;
          } else if (r.isNull) {
            // caso isNull
            range.isNull = true;
          } else {
            // caso con operador: op, value
            // aceptamos <=, <, >=, >, ==, !=, etc. según lo que emita tu UI
            range.op = String(r.op || '').trim();
            range.value = String(r.value == null ? '' : r.value);
          }
          // output siempre string
          range.output = String(r.output == null ? '' : r.output);
          return range;
        }).filter(function (r) {
          return 'default' in r || r.op && 'value' in r || r.isNull;
        });
        console.log('normalized ranges for item', item, ranges);
        return {
          source_table: sourceTable,
          column: item.attribute_name,
          ranges: ranges
        };
      });
    },
    normalizeArea: function normalizeArea(area) {
      return (area || '').toString().trim().toLowerCase();
    },
    getBucketForArea: function () {
      var _getBucketForArea = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(area) {
        var bucket, BUCKET_BY_AREA;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return UseCasesService.getBucketByArea(area);
            case 1:
              bucket = _context4.v;
              console.log('Bucket from service', bucket);
              BUCKET_BY_AREA = {
                'riesgos': 'prd-ibk-rsk-request-sandbox-hdk6',
                'retail': 'prd-ibk-retail-request-sandbox-kzh7',
                'business analytics': 'prd-ibk-ba-request-sandbox-rg8u',
                'data office intercorp': 'prd-ibk-itc-request-sandbox-hdk6'
              };
              return _context4.a(2, bucket[0] || BUCKET_BY_AREA[this.normalizeArea(area)] || '');
          }
        }, _callee4, this);
      }));
      function getBucketForArea(_x2) {
        return _getBucketForArea.apply(this, arguments);
      }
      return getBucketForArea;
    }(),
    buildBinningRequest: function () {
      var _buildBinningRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this0 = this;
        var businessArea, bucket, process_dates, table, rangesById;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              businessArea = this.form.selected_use_case.area_name;
              _context5.n = 1;
              return this.getBucketForArea(businessArea);
            case 1:
              bucket = _context5.v;
              console.log('Determined bucket', bucket, 'for area', businessArea);
              process_dates = (this.chips || []).map(function (chip) {
                return _this0.toProcessDate(chip.id);
              }) // chip.id = 'YYYYMM'
              .filter(Boolean);
              table = [];
              rangesById = new Map((this.rangeSections || []).map(function (s) {
                return [String(s.id), Array.isArray(s.ranges) ? s.ranges : []];
              }));
              this.internalSelected.forEach(function (item) {
                if (item) {
                  var rawRanges = rangesById.get(String(item.id)) || [];
                  console.log('rawRanges for item', item, rawRanges);
                  var ranges = rawRanges.map(function (r) {
                    var range = {};
                    if (r.default === true) {
                      // caso default
                      range.default = true;
                    } else if (r.isNull) {
                      // caso isNull
                      range.isNull = true;
                    } else {
                      // caso con operador: op, value
                      // aceptamos <=, <, >=, >, ==, !=, etc. según lo que emita tu UI
                      range.op = String(r.op || '').trim();
                      range.value = String(r.value == null ? '' : r.value);
                    }
                    // output siempre string
                    range.output = String(r.output == null ? '' : r.output);
                    return range;
                  }).filter(function (r) {
                    return 'default' in r || r.op && 'value' in r || r.isNull;
                  });
                  table.push({
                    'attribute_object_name': item.attribute_object_name,
                    'attribute_scheme_name': item.attribute_scheme_name,
                    'attribute_project_name': item.attribute_project_name,
                    'attribute_name': item.attribute_name,
                    'attribute_category': item.attribute_category,
                    'attribute_data_type': item.attribute_data_type,
                    'ranges': ranges
                  });
                }
              });
              return _context5.a(2, {
                usecase_id: this.form.selected_use_case.id,
                company_code_usr: this.companyCode,
                export_detail: this.form.description || '',
                owner_name: window.userInfo.email,
                period: this.chips.map(function (chip) {
                  return chip.id;
                }),
                table_detail: table,
                use_case: this.form.selected_use_case && this.form.selected_use_case.business_name || '',
                destination_scheme: this.form.selected_use_case.db_write_name,
                table_name: this.form.segment || '',
                business_area: businessArea,
                bucket_name: bucket,
                process_dates: process_dates,
                model: this.form.model,
                attributes: this.buildAttributesFromSelection(),
                origen_ejecucion: 'INCA'
              });
          }
        }, _callee5, this);
      }));
      function buildBinningRequest() {
        return _buildBinningRequest.apply(this, arguments);
      }
      return buildBinningRequest;
    }(),
    SaveAndExecute: function () {
      var _SaveAndExecute = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this1 = this;
        var table, array_period, destination_scheme, datos, src, isAthena, isBinning, payload, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              this.setShowLoading(true);
              if (!(!this.isBinning && (!this.hasFile || !this.fileBase64))) {
                _context6.n = 1;
                break;
              }
              alert('Por favor, espera a que el archivo se cargue completamente.');
              return _context6.a(2);
            case 1:
              if (this.form.has_pls) {
                this.generateJson();
              } else {
                this.jsonOutput = null;
              }
              console.log('SaveAndExecute');
              if (this.validate()) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              this.verificarChipsYAtributos();
              if (!(!this.isValidChips || !this.isValidAttributes || !this.isValidTree)) {
                _context6.n = 3;
                break;
              }
              this.e1--;
              this.$emit('update-step', this.e1);
              this.setShowLoading(false);
              return _context6.a(2);
            case 3:
              table = [];
              this.internalSelected.forEach(function (item) {
                if (item) {
                  table.push({
                    'attribute_object_name': item.attribute_object_name,
                    'attribute_scheme_name': item.attribute_scheme_name,
                    'attribute_project_name': item.attribute_project_name,
                    'attribute_name': item.attribute_name,
                    'attribute_category': item.attribute_category,
                    'attribute_data_type': item.attribute_data_type
                  });
                }
              });
              // this.externalSelected.forEach(item => {
              //   if (item) {
              //     table.push({
              //       'attribute_object_name': item.attribute_object_name,
              //       'attribute_scheme_name': item.attribute_scheme_name,
              //       'attribute_project_name': item.attribute_project_name,
              //       'attribute_name': item.attribute_name,
              //       'attribute_category': item.attribute_category
              //     })
              //   }
              // })
              array_period = [];
              array_period.push("".concat(this.selectedYear).concat(this.selectedMonth));
              destination_scheme = this.form.selected_destination_scheme ? this.form.selected_destination_scheme : this.form.destination_scheme;
              datos = {
                'scr_b64': this.fileBase64,
                'segment': this.form.segment,
                'company_code_usr': this.companyCode,
                'type_export_id': this.form.type_export.id,
                'destination_scheme': destination_scheme,
                'export_detail': this.form.description,
                'owner_name': window.userInfo.email,
                'table_detail': table,
                'period': this.chips.map(function (chip) {
                  return chip.id;
                }),
                'pls': this.jsonOutput,
                'has_pls': this.form.has_pls,
                'is_editing': this.mode === 'update',
                'model': this.form.model
              };
              src = this.form && this.form.selected_use_case && this.form.selected_use_case.source ? this.form.selected_use_case.source : null;
              isAthena = !!src && String(src).toLowerCase() === 'athena';
              isBinning = this.form && this.form.transformation_type && this.form.transformation_type === 'Binning';
              if (!(isAthena && isBinning)) {
                _context6.n = 10;
                break;
              }
              _context6.p = 4;
              _context6.n = 5;
              return this.buildBinningRequest();
            case 5:
              payload = _context6.v;
              // Log para verificar que coincide con el contrato del backend
              console.log('POST /postSaveTransformedAttributesBinning payload:', payload);
              _context6.n = 6;
              return UseCasesService.postSaveTransformedAttributesBinning(payload, this.form.selected_use_case.id // si tu API usa path param de use case
              );
            case 6:
              tasks.toast.success(this.translate('frases.successfully_registered'));
              this.$emit('get-history');
              this.$emit('close-modal-create');
              _context6.n = 8;
              break;
            case 7:
              _context6.p = 7;
              _t4 = _context6.v;
              console.error(_t4);
              tasks.toast.error('Error al enviar la configuración de binning.');
            case 8:
              _context6.p = 8;
              this.setShowLoading(false);
              return _context6.f(8);
            case 9:
              return _context6.a(2);
            case 10:
              UseCasesService.postSaveTransformedAttributes(datos, this.form.selected_use_case.id).then(function (response) {
                if (response && response.data) {
                  _this1.setShowLoading(false);
                  tasks.toast.success(_this1.translate('frases.successfully_registered'));
                  _this1.$emit('get-history');
                  _this1.$emit('close-modal-create');
                }
              }).catch(function (error) {
                console.error(error);
                _this1.setShowLoading(false);
              });
            case 11:
              return _context6.a(2);
          }
        }, _callee6, this, [[4, 7, 8, 9]]);
      }));
      function SaveAndExecute() {
        return _SaveAndExecute.apply(this, arguments);
      }
      return SaveAndExecute;
    }(),
    UpdateAndExecute: function UpdateAndExecute() {
      var _this10 = this;
      console.log('jsonOutput: ', this.jsonOutput);
      console.log(this.initialData, 'initialData');
      this.setShowLoading(true);
      if (!this.hasFile || !this.fileBase64) {
        alert('Por favor, espera a que el archivo se cargue completamente.');
        return;
      }
      if (this.form.has_pls) {
        this.generateJson();
      } else {
        this.jsonOutput = null;
      }
      if (!this.validate()) {
        return;
      }
      this.verificarChipsYAtributos();
      if (!this.isValidChips || !this.isValidAttributes || !this.isValidTree) {
        this.e1--;
        this.$emit('update-step', this.e1);
        this.setShowLoading(false);
        return;
      }
      var array_period = [];
      array_period.push("".concat(this.selectedYear).concat(this.selectedMonth));
      var automation_id = this.initialData.automate_id;
      var datos = {
        src_b64: this.fileBase64,
        pls: this.jsonOutput,
        has_pls: this.form.has_pls,
        use_case_id: this.form.selected_use_case.id,
        period: this.chips.map(function (chip) {
          return chip.id;
        }),
        segment: this.form.segment,
        owner_name: window.userInfo.email,
        type_export_id: this.form.type_export.id,
        table_detail: this.internalSelected.map(function (item) {
          return {
            attribute_object_name: item.attribute_object_name,
            attribute_scheme_name: item.attribute_scheme_name,
            attribute_project_name: item.attribute_project_name,
            attribute_name: item.attribute_name,
            attribute_category: item.attribute_category,
            attribute_data_type: item.attribute_data_type
          };
        }),
        model: this.form.model
      };
      UseCasesService.updateTransformedAttributes(datos, automation_id).then(function (response) {
        console.log('response', response);
        _this10.setShowLoading(false);
        tasks.toast.success(_this10.translate('frases.successfully_updated'));
        _this10.$emit('get-history');
        _this10.$emit('close-modal-create');
      }).catch(function (error) {
        console.error(error);
        _this10.setShowLoading(false);
      });

      //UseCasesService.updateAttributeGroup()
      //UseCasesService.postSaveTransformedAttributesPeriod()
    },
    onFileSelected: function onFileSelected() {
      var _this11 = this;
      if (!this.form.py_file) {
        this.hasFile = false;
        return;
      }

      // Obtén la extensión del archivo
      var fileExtension = this.form.py_file.name.split('.').pop();

      // Verifica si la extensión del archivo es .py
      if (fileExtension !== 'py') {
        this.hasFile = false;
        this.form.py_file = null;
        this.fileBase64 = null;
        this.File = [];
        this.keyPrevisualize += 1;
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        // this.fileBase64 = event.target.result
        _this11.fileBase64 = event.target.result.split(',')[1];
        _this11.hasFile = true;
      };
      reader.readAsDataURL(this.form.py_file);
    },
    fetchCatalogs: function () {
      var _fetchCatalogs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this12 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              try {
                UseCasesService.getExportTypes().then(function (response) {
                  if (response.success) {
                    var exportTypes = response.data.export_type_catalog_id;
                    exportTypes = {
                      '4': exportTypes['4']
                    };
                    _this12.type_export_items = Object.keys(exportTypes).map(function (key) {
                      return {
                        id: key,
                        export_type_name: exportTypes[key].name
                      };
                    });
                  }
                });
              } catch (error) {
                console.error(error);
              }
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }));
      function fetchCatalogs() {
        return _fetchCatalogs.apply(this, arguments);
      }
      return fetchCatalogs;
    }(),
    listTables: function listTables() {
      var _this13 = this;
      if (this.form.selected_use_case.source.toLowerCase() == 'bigquery') {
        UseCasesService.getUseCaseById(this.form.selected_use_case.company_code, this.form.selected_use_case.id).then(function (response) {
          if (response.success) {
            console.log('response.data.attributes', response.data.attributes);
            _this13.tableInternalItems = response.data.attributes.filter(function (attribute) {
              return attribute.is_external === '0';
            }).map(function (a) {
              return _objectSpread(_objectSpread({}, a), {}, {
                uid: "".concat(a.attribute_project_name, ".").concat(a.attribute_scheme_name, ".").concat(a.attribute_object_name, ".").concat(a.attribute_name)
              });
            });
            _this13.pagination.total = _this13.tableInternalItems.length;
            // this.tableExternalItems = response.data.attributes.filter(attribute => attribute.is_external === '1')
            _this13.keyTable += 1;
            _this13.keyTable2 += 1;
            _this13.internalSelected = _this13.tableInternalItems.filter(function (item) {
              return _this13.attributes_array.includes(item.attribute_name);
            });
          }
        });
      } else if (this.form.selected_use_case.source.toLowerCase() === 'athena') {
        var promises = this.attributes_array.map(function (attribute) {
          var filtro = _objectSpread(_objectSpread({}, _this13.filtro), {}, {
            q: attribute,
            company_code: _this13.form.selected_use_case.company_code
          });
          return search_engine_service.getBuscadorAtributos(filtro).then(function (response) {
            if (response.busqueda && response.busqueda.length > 0) {
              var match = response.busqueda.find(function (item) {
                return item.nombre.toLowerCase() === attribute.toLowerCase();
              });
              if (match) {
                var uid = [match.proyecto, match.dataset, match.tabla, match.nombre].map(function (x) {
                  return String(x || '').toLowerCase();
                }).join('::');
                return {
                  uid: uid,
                  id: match.id,
                  attribute_name: match.nombre,
                  attribute_object_name: match.tabla,
                  attribute_scheme_name: match.dataset,
                  attribute_project_name: match.proyecto,
                  attribute_category: match.categoria,
                  attribute_data_type: match.tipo_dato
                };
              }
            }
            return null;
          }).catch(function (error) {
            console.error("Error buscando atributo \"".concat(attribute, "\""), error);
            return null;
          });
        });
        Promise.all(promises).then(function (results) {
          // Filtrar los nulos
          _this13.tableInternalItems = results.filter(Boolean);
          _this13.keyTable += 1;
          _this13.internalSelected = _this13.tableInternalItems.filter(function (item) {
            return _this13.attributes_array.includes(item.attribute_name);
          });
        });
      }

      // try {
      //   const data = {
      //     type_export_id: this.form.type_export.id,
      //     scr_b64: this.fileBase64
      //   }
      //   UseCasesService.postReadFile(data, this.form.selected_use_case.company_code, this.form.selected_use_case.id).then((response) => {
      //     if (!response.data.records || response.data.records.length < 1) {
      //       this.e1--
      //       this.$emit('update-step', this.e1)
      //       tasks.toast.info('' + response.data.observation, 'Información')
      //       return
      //     }
      //     // this.tableInternalItems = response.data.records
      //     this.tableInternalItems = response.data.records.map(record => ({
      //       ...record,
      //       flag_copy: false,
      //       flag_access: false
      //     }))
      //     this.getObjectAccess()
      //   })
      // } catch (error) {
      //   console.error(error)
      // }
    },
    readPythonFile: function readPythonFile() {
      this.setShowLoading(true);
      if (!this.hasFile || !this.fileBase64) {
        alert('Por favor, espera a que el archivo se cargue completamente.');
        return;
      }
      var decodedFile = Buffer.from(this.fileBase64, 'base64');
      var pythonFile = decodedFile.toString('utf8');
      var terms = pythonFile.split(/\s+/);
      var df_output_terms = [];
      var _iterator2 = _createForOfIteratorHelper(terms),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var term = _step2.value;
          if (/df_attribute\[['"]/.test(term)) {
            console.log(/df_attribute\[['"]/.test(term), 'term', term);
            df_output_terms.push(term);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.attributes_array = this.extraerAtributesDeArray(df_output_terms);
      console.log('attributes_array', this.attributes_array);
      this.setShowLoading(false);
    },
    extraerAtributesDeArray: function extraerAtributesDeArray(extracted_values) {
      var combinedString = extracted_values.join(' ');

      // Extract matches using a regular expression
      var pattern = /df_attribute\[['"]([a-zA-Z0-9_]+)['"]\]/g;
      var matches = new Set();
      var match;
      while ((match = pattern.exec(combinedString)) !== null) {
        matches.add(match[1]);
      }

      // Convert the set to an array
      return Array.from(matches);
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this14 = this;
      domainService.getOrganizationsDetail(undefined, {
        lock: false
      }).then(function (response) {
        if (response.success) {
          _this14.list_orgs = response.data;
        }
      });
    },
    getCodeFromDomain: function getCodeFromDomain(domain) {
      var entry = this.list_orgs.find(function (item) {
        return item.domain === domain;
      });
      return entry ? entry.code : null;
    },
    arrayContains: function arrayContains(arr1, arr2) {
      if (arr1.length < arr2.length) {
        return false;
      }
      var sortedArr1 = arr1.slice().sort();
      var sortedArr2 = arr2.slice().sort();
      for (var i = 0; i < sortedArr1.length; i++) {
        if (!sortedArr1.includes(sortedArr2[i])) {
          return false;
        }
      }
      return true;
    },
    addChip: function addChip() {
      var _this15 = this;
      if (this.chips.length >= this.maxChips) {
        return;
      }
      if (this.selectedYear && this.selectedMonth && /^\d{4}$/.test(this.selectedYear)) {
        var month_name = this.months.find(function (month) {
          return month.value === _this15.selectedMonth;
        }).name;
        var chipId = "".concat(this.selectedYear).concat(this.selectedMonth);
        var chipDisplay = "".concat(month_name, " ").concat(this.selectedYear);
        if (!this.chips.find(function (chip) {
          return chip.id === chipId;
        })) {
          this.chips.push({
            id: chipId,
            display: chipDisplay
          });
        }
        this.selectedMonth = null;
      }
      this.verificarChipsYAtributos();
    },
    removeChip: function removeChip(index) {
      this.chips.splice(index, 1);
      this.verificarChipsYAtributos();
    },
    verificarChipsYAtributos: function verificarChipsYAtributos() {
      this.isValidChips = this.isBinning ? this.chips.length > 0 && this.chips.length <= this.maxChips : this.chips.length > 0;
      console.log('this.internalSelected.length', this.internalSelected.length);
      this.isValidAttributes = this.internalSelected.length > 0;
      this.isValidTree = this.groups.every(function (group) {
        return group.children.length >= 2;
      });
    },
    ListIbkAwsSchemes: function ListIbkAwsSchemes() {
      var _this16 = this;
      UseCasesService.getIbkAwsSchemes(false).then(function (response) {
        if (response.success) {
          _this16.aws_schemes = response.data.records;
        }
      });
    },
    addGroup: function addGroup() {
      var groupId = this.nextId++;
      var newGroup = {
        id: groupId,
        comp: "comp".concat(this.groups.length + 1),
        type: 'group',
        children: [{
          id: this.nextId++,
          type: 'child',
          atributo: '',
          peso: '',
          groupId: groupId
        }, {
          id: this.nextId++,
          type: 'child',
          atributo: '',
          peso: '',
          groupId: groupId
        }]
      };
      this.groups.push(newGroup);
      this.open.push(newGroup.id);
    },
    addChild: function addChild(groupId) {
      var group = this.groups.find(function (g) {
        return g.id === groupId;
      });
      group.children.push({
        id: this.nextId++,
        type: 'child',
        atributo: '',
        peso: '',
        groupId: groupId
      });
      if (!this.open.includes(groupId)) {
        this.open.push(groupId);
      }
    },
    removeGroup: function removeGroup(groupId) {
      this.groups = this.groups.filter(function (group) {
        return group.id !== groupId;
      });
    },
    removeChild: function removeChild(childId) {
      this.groups.forEach(function (group) {
        group.children = group.children.filter(function (child) {
          return child.id !== childId;
        });
      });
    },
    generateJson: function generateJson() {
      var result = {};
      this.groups.forEach(function (group) {
        result[group.comp] = group.children.map(function (child) {
          return {
            atributo: child.atributo,
            peso: child.peso,
            tabla: 'df_attribute'
          };
        });
      });
      this.jsonOutput = result;
      // this.jsonOutput = JSON.stringify(result, null, 2)
      // console.log(this.jsonOutput)
    },
    isLastChild: function isLastChild(item) {
      var group = this.groups.find(function (g) {
        return g.id === item.groupId;
      });
      return group && group.children[group.children.length - 1].id === item.id;
    }
  }
};